import { Close } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { useState } from 'react';

const RendirEfectivoModal = ({ open, onClose, onRendir, caja, loading }) => {
  const [montoEfectivo, setMontoEfectivo] = useState("");
  const [observaciones, setObservaciones] = useState("");

  const resetForm = () => {
    setMontoEfectivo("");
    setObservaciones("");
  };



  const handleSubmit = () => {
    if (!montoEfectivo || parseFloat(montoEfectivo) <= 0) return;

    onRendir({
      monto_efectivo: parseFloat(montoEfectivo),
      observaciones: observaciones
    });

    resetForm();
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const saldoDisponible = caja?.saldo_caja || 0;
  const montoValido = montoEfectivo && parseFloat(montoEfectivo) > 0 && parseFloat(montoEfectivo) <= saldoDisponible;

  const tieneError = Boolean(montoEfectivo && (!montoValido || parseFloat(montoEfectivo) > saldoDisponible));
  return (
    <Dialog
      open={open}
      onClose={!loading ? handleClose : undefined}
      disableEscapeKeyDown={loading}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{
            fontFamily: "Bricolage Grotesque",
            color: "#0b0062",
            fontWeight: 600
          }}>
            Rendir - {caja?.caja}
          </Typography>
          {!loading && (
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* CAJA */}
        <Box sx={{
          mb: 3,
          p: 2,
          backgroundColor: "#f5f5f5",
          borderRadius: 2,
          border: "1px solid #e0e0e0"
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Typography sx={{ fontWeight: 600, color: "#0b0062", mb: 1 }}>
              {caja?.nombre_completo}
            </Typography>
            <Typography sx={{ color: "#666", fontSize: "14px", mb: 1 }}>
              {caja?.usuario}
            </Typography>
          </Box>
          <Typography sx={{ color: "#666", fontSize: "14px", mb: 1 }}>
            <strong>Monto total <em>(QR + Efectivo)</em>:</strong> ${(caja?.monto_total || 0).toLocaleString('es-AR')}
          </Typography>
          <Typography sx={{
            color: saldoDisponible > 0 ? "#2e7d32" : "#666",
            fontSize: "16px",
            fontWeight: 600
          }}>
            <strong>Saldo en efectivo:</strong> ${saldoDisponible.toLocaleString('es-AR')}
          </Typography>
        </Box>

        <Typography sx={{ mb: 1, color: "#0b0062", fontWeight: 500 }}>
          Monto a rendir <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          type="number"
          value={montoEfectivo}
          onChange={(e) => setMontoEfectivo(e.target.value)}
          fullWidth
          placeholder="0.00"
          inputProps={{
            min: 0,
            max: saldoDisponible,
            step: 0.01
          }}
          error={tieneError}
          helperText={
            montoEfectivo && parseFloat(montoEfectivo) > saldoDisponible
              ? `El monto no puede superar el saldo disponible (${saldoDisponible.toLocaleString('es-AR')})`
              : ""
          }
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input': {
              fontFamily: "Bricolage Grotesque",
              fontSize: "15px",
              height: "40px",
              boxSizing: "border-box",
              padding: "8px 12px",
            },
            '& .MuiOutlinedInput-root': {
              height: "40px",
              '& fieldset': { borderColor: '#B2BAC2' },
              '&:hover fieldset': { borderColor: '#5656ff' },
              '&.Mui-focused fieldset': { borderColor: '#5656ff' },
            }
          }}
        />

        <Typography sx={{ mb: 1, color: "#0b0062", fontWeight: 500 }}>
          Observaciones (opcional)
        </Typography>
        <TextField
          multiline
          rows={3}
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          fullWidth
          placeholder="Agregar observaciones sobre la rendición..."
          sx={{
            fontFamily: "Bricolage Grotesque",
            '& .MuiInputBase-input': {
              fontFamily: "Bricolage Grotesque",
              fontSize: "15px",
              padding: "8px 12px",
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: '#B2BAC2' },
              '&:hover fieldset': { borderColor: '#5656ff' },
              '&.Mui-focused fieldset': { borderColor: '#5656ff' },
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          sx={{
            border: "1px solid #ccc",
            color: "#666",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "50%"
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={loading || !montoValido}
          variant="contained"
          sx={{
            backgroundColor: "#5656FF",
            color: "white",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "50%",
            '&:disabled': {
              backgroundColor: "#ccc"
            }
          }}
        >
          {loading ? <CircularProgress size={20} /> : "Rendir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RendirEfectivoModal;